import { Component } from '@angular/core';
import { FernLernformService } from '../../../../services/facetten/instance/lernformen-facetten/fernlernform.service';
import { LernformFacettenService } from '../../../../services/facetten/instance/lernformen-facetten/lernformfacetten.service';
import { UnterrichtsformBasisFacetteComponent } from '../unterrichtsform-basis-facette/unterrichtsform-basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-fernunterricht-facette',
  templateUrl: './fernunterricht-facette.component.html',
  imports: [UnterrichtsformBasisFacetteComponent],
  providers: [
    // Hier wird der LernformFacettenService injected, welcher dann in der UnterrichtsFormBasisFacette verwendet werden kann
    { provide: LernformFacettenService, useExisting: FernLernformService }
  ]
})
export class FernunterrichtFacetteComponent {}
